/**
 * DEMO-ONLY: sessionStorage-backed pricing requests for mock ICM (MVP 2.2.1 / 2.3.1 / 3.3.x).
 * Status / quote # outcomes are shown on inbound Quotes from sales; this store holds request content.
 */
import { PresidioPricingRequest } from '../../quoting/models/presidio-pricing-request.model';

/** Bumped when seed shape changes (affiliate company on summary/detail). */
export const PRESIDIO_MOCK_PRICING_REQUESTS_KEY = 'presidio-mock-pricing-requests-v4';

const SEED: PresidioPricingRequest[] = [
  {
    id: 'PR-SEED-1',
    number: 'PR-2201',
    title: 'Cart pricing request',
    requestor: 'Jordan Hale',
    status: 'Quoted',
    creationDate: '2026-09-10T14:00:00.000Z',
    quoteNumber: 'Q-88421',
    total: 42850,
    fromBasket: true,
    affiliatedCompany: 'Acme Healthcare',
    comment: 'Need contract pricing for Q4 refresh.',
    items: [
      { sku: 'NV-L40S-48G', name: 'NVIDIA L40S GPU', quantity: 2, unitPrice: 12425 },
      { sku: 'PRS-NET-400G', name: '400G interconnect kit', quantity: 1, unitPrice: 18000 },
    ],
  },
  {
    id: 'PR-SEED-2',
    number: 'PR-2200',
    title: 'Custom BOM request',
    requestor: 'Jordan Hale',
    status: 'Open',
    creationDate: '2026-09-18T09:30:00.000Z',
    attachmentName: 'custom-bom.xlsx',
    fromBasket: false,
    affiliatedCompany: 'Beta Manufacturing',
    comment: 'Off-catalog line items attached.',
  },
];

export function readPresidioMockPricingRequests(): PresidioPricingRequest[] {
  if (typeof sessionStorage === 'undefined') {
    return SEED.map(row => ({ ...row, items: row.items?.map(i => ({ ...i })) }));
  }
  try {
    const raw = sessionStorage.getItem(PRESIDIO_MOCK_PRICING_REQUESTS_KEY);
    if (raw === null) {
      writePresidioMockPricingRequests(SEED.map(row => ({ ...row, items: row.items?.map(i => ({ ...i })) })));
      return SEED.map(row => ({ ...row, items: row.items?.map(i => ({ ...i })) }));
    }
    return JSON.parse(raw) as PresidioPricingRequest[];
  } catch {
    return SEED.map(row => ({ ...row, items: row.items?.map(i => ({ ...i })) }));
  }
}

export function writePresidioMockPricingRequests(rows: PresidioPricingRequest[]): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  sessionStorage.setItem(PRESIDIO_MOCK_PRICING_REQUESTS_KEY, JSON.stringify(rows));
}

export function appendPresidioMockPricingRequest(row: PresidioPricingRequest): PresidioPricingRequest[] {
  const next = [row, ...readPresidioMockPricingRequests()];
  writePresidioMockPricingRequests(next);
  return next;
}

export function findPresidioMockPricingRequest(id: string): PresidioPricingRequest | undefined {
  return readPresidioMockPricingRequests().find(row => row.id === id || row.number === id);
}
